"use strict";
import RecruitApiClient from "../../RecruitApiClient";
class Api {
  constructor() {
    this.getSearches = (page = 1, limit = 20, sort = "id", sortOrder = "desc", query) => {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        sort,
        sort_order: sortOrder
      });
      if (query) {
        params.append("query", query);
      }
      return RecruitApiClient.get(`/api/v4/candidate_sourcing/searches?${params.toString()}`);
    };
    this.getCandidatePools = (page = 1, limit = 20, sort = "id", sortOrder = "desc", query) => {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        sort,
        sort_order: sortOrder
      });
      if (query) {
        params.append("query", query);
      }
      return RecruitApiClient.get(`/api/v4/candidate_sourcing/candidate_pools?${params.toString()}`);
    };
    this.deleteSearch = (id) => RecruitApiClient.delete(`/api/v4/candidate_sourcing/searches/${id}`);
    this.deleteCandidatePool = (id) => RecruitApiClient.delete(`/api/v4/candidate_sourcing/candidate_pools/${id}`);
  }
}
export default new Api();
